import React from 'react'
import { SearchBox } from '../../../search'
import Refinement from '../../../search/refinement'
import type { SearchSectionProps } from './SearchSection'
import { TitleHighlight } from '../../../ui/typo/TitleHighlight'
import { HomeHeading } from '../../home/Heading'
import { RefinementListProps } from '../../../search/refinementList'

interface OfferListHeroProps {
  searchClient: SearchSectionProps['searchClient']
  googleMapsApiKey: SearchSectionProps['googleMapsApiKey']
  refinementAttributes: RefinementListProps[]
}

export const OfferListHero = ({
  searchClient,
  googleMapsApiKey,
  refinementAttributes,
}: OfferListHeroProps) => (
  <section id="offer-list-hero" className="pt-8 md:py-12 lg:py-14 xl:py-18">
    <div className="px-4 py-8 space-y-12 md:px-0">
      <HomeHeading tag="h1">
        Ton prochain job en <TitleHighlight>cabinet</TitleHighlight> est ici
      </HomeHeading>

      <SearchBox
        autoCompleteAttributeName="jobType"
        searchClient={searchClient}
        googleMapsApiKey={googleMapsApiKey}
        placeholder={{
          input: 'Poste, cabinet, mots clés...',
          place: 'Adresse ou ville...',
        }}
      />
    </div>

    <Refinement attributes={[...refinementAttributes]} />
  </section>
)
